import { isConnectedBlockType } from '../flow/connectedBlocks';
import { isFlowSection } from '../../lib/sectionLayoutMode';
import { isProductGalleryContent } from '../../lib/productGallery';
import type {
  CanvasSectionBlock,
  HomepageLayoutSection,
  HomepageSectionSettings,
} from './sectionRegistry';

function getSectionBlocks(settings: HomepageSectionSettings | undefined): CanvasSectionBlock[] {
  return Array.isArray(settings?.canvas?.blocks) ? settings!.canvas!.blocks : [];
}

function isSupportedFlowBlock(block: CanvasSectionBlock) {
  if (block.type === 'request-form' || block.type === 'site-footer' || block.type === 'site-progress') {
    return true;
  }

  if (block.type === 'gallery') {
    return isProductGalleryContent(block.content);
  }

  if (isConnectedBlockType(block.type)) {
    return block.type !== 'gallery' && block.type !== 'product-card';
  }

  return false;
}

export function resolveFlowSectionBlocks(settings: HomepageSectionSettings | undefined) {
  return getSectionBlocks(settings)
    .slice()
    .sort((left, right) => {
      if (left.layout.y !== right.layout.y) return left.layout.y - right.layout.y;
      if (left.layout.x !== right.layout.x) return left.layout.x - right.layout.x;
      return left.id.localeCompare(right.id);
    });
}

export function supportsFlowSectionRendering(
  section: Pick<HomepageLayoutSection, 'type' | 'settings'> | null | undefined
) {
  if (!section || section.type !== 'canvas' || !isFlowSection(section)) return false;
  const blocks = resolveFlowSectionBlocks(section.settings);
  return blocks.length > 0 && blocks.every(isSupportedFlowBlock);
}
